export interface DashboardWidget {
  id: string;
  type: string;
  title: string;
  layout: WidgetLayout;
  config?: WidgetConfig;
}

export interface WidgetLayout {
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  minH?: number;
}

export interface WidgetConfig {
  aggregationType?: string;
  field?: string;
  chartType?: string;
  interval?: string;
  size?: number;
  filters?: WidgetFilters;
}

export interface WidgetFilters {
  from?: string;
  to?: string;
  agentName?: string;
  direction?: string;
  interactionType?: string;
  skill?: string;
  group?: string;
  tags?: string[];
}

export interface DashboardConfigResponse {
  customerId: string;
  widgets: DashboardWidget[];
  updatedAt: string;
}

export interface AggregateRequest {
  aggregationType: string;
  field?: string;
  interval?: string;
  size?: number;
  timeZone?: string;
  from?: string;
  to?: string;
  agentName?: string;
  direction?: string;
  interactionType?: string;
  skill?: string;
  group?: string;
  tags?: string[];
}

export interface AggregateResponse {
  labels: string[];
  values: number[];
  total: number;
}

// Well-known widget types that match the backend WidgetTypes constants
export const WIDGET_TYPES = {
  LEGAL_HOLD: "legal_hold",
  PURGING: "purging",
  TOTAL_INTERACTIONS: "total_interactions",
  TAGS: "tags",
  INTERACTIONS_BY_YEAR: "interactions_by_year",
  MEDIA_TYPE: "media_type",
  CUSTOM_AGGREGATE: "custom_aggregate",
} as const;
